import { ServiceList } from './ServiceList'
import { ServiceCreate } from './ServiceCreate'
import { ServiceEdit } from './ServiceEdit'

export { ServiceList, ServiceCreate, ServiceEdit }


// WEBPACK FOOTER //
// ./src/components/service/index.js